import exchanges from './exchanges';
import report from './report';

export default (F) => ({
  ...exchanges(F),
  ...report(F),
});
